import { Controller } from "@hotwired/stimulus"
export default class extends Controller {

    static targets = ['tab', 'panel'];

    connect() {
        this.showTab(0);
    }

    select(e) {
        const index = this.tabTargets.indexOf(e.currentTarget);
        this.showTab(index);
    }

    showTab(index) {
        this.tabTargets.forEach((tab, i) => {
            const isActive = i === index;
            tab.setAttribute('aria-selected', isActive);
            tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.panelTargets.forEach((panel, i) => {
            panel.hidden = i !== index;
        });
    }

    // Navigation clavier accessible
    keydown(e) {
        const tabs = this.tabTargets;
        const index = tabs.indexOf(e.currentTarget);

        let next;
        if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft')  next = (index - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home')       next = 0;
        if (e.key === 'End')        next = tabs.length - 1;

        if (next !== undefined) {
            e.preventDefault();
            this.showTab(next);
            tabs[next].focus();
        }
    }
}